import MRMLogo from "@/assets/images/LogoMRM-HD.png";
import MRMname from "@/assets/images/murillo-HD.png";
import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { Menu } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const StyledLogoImg = styled.img`
  transform: scale(0.5);
`;

export const AppBar = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile(780);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          position: "fixed",
          width: "100%",
          minHeight: "4rem",
          padding: "1rem 2rem ",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "white",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Box sx={{ width: "fit-content" }}>
            <img src={MRMLogo} width={"75px"} alt="MRM Logo" />
          </Box>
          <Box sx={{ width: isMobile ? "15rem" : "20rem" }}>
            <img src={MRMname} alt="MRM Name" />
          </Box>
        </Box>
        <Box sx={{ display: { xs: "none", sm: "flex" }, gap: "1rem" }}>
          <Button
            variant="outline"
            style={{
              minWidth: isMobile ? "5rem" : "8.5rem",
              fontSize: isMobile ? "12px" : undefined,
            }}
            onClick={() => {
              navigate("/login");
            }}
          >
            Iniciar Sesion
          </Button>
          <Button
            variant="contained"
            style={{
              minWidth: isMobile ? "5rem" : "8.5rem",
              fontSize: isMobile ? "12px" : undefined,
            }}
            onClick={() => {}}
          >
            Contactanos
          </Button>
        </Box>
        <Box sx={{ display: { xs: "flex", sm: "none" } }}>
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-1">
              <Button variant="icon" size="icon">
                <Menu className="min-w-6 min-h-6 text-[#1F6B45] " />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem>
                <Typography
                  fontFamily="Inter"
                  fontSize={14}
                  fontWeight={400}
                  className="text-black text-sm cursor-pointer hover:underline hover:text-[#1F6B45]"
                  sx={{ textDecoration: "none" }}
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Iniciar Sesion
                </Typography>
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Typography
                  fontFamily="Inter"
                  fontSize={14}
                  fontWeight={400}
                  className="text-black text-sm cursor-pointer hover:underline hover:text-[#1F6B45]"
                  sx={{ textDecoration: "none" }}
                >
                  Contactanos
                </Typography>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </Box>
      </Box>
    </>
  );
};

export default AppBar;
